import { render, staticRenderFns } from "./CartOrderFooter.vue?vue&type=template&id=1ae6e1cb&scoped=true&"
import script from "./CartOrderFooter.vue?vue&type=script&lang=ts&"
export * from "./CartOrderFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CartOrderFooter.vue?vue&type=style&index=0&id=1ae6e1cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae6e1cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
